import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ThankYouPage = () => {
  const location = useLocation();
  const history = useHistory();
  const { logout } = useAuth();
  const message = location.state?.message || 'Thank you for completing the assessment.';

  const handleExit = useCallback(() => {
    logout();
    history.replace('/login');
  }, [history, logout]);

  return (
    <div className="thankyou-page">
      <div className="thankyou-card">
        <h1>Assessment Submitted</h1>
        <p>{message}</p>
        <button type="button" onClick={handleExit}>
          Sign out
        </button>
      </div>
    </div>
  );
};

export default ThankYouPage;
